export { HBHighlightText } from './HBHighlightText';
export type { HBHighlightTextProps } from './HBHighlightText.types';
export { useHighlightText } from './useHighlightText';
export type {
    HighlightSegment,
    UseHighlightTextOptions
} from './useHighlightText';
